<template>
    <div class="curTicker">
        <div class="tValue">1</div>
        <div class="tName">{{ cur1 }}</div>
        <span>=</span>
        <div class="tValue">{{ value2 }}</div>
        <div class="tName">{{ cur2 }}</div>
    </div>
</template>

<script>
import StockPriceHelperMixin from '../../../../helpers/StockPriceHelperMixin';
export default {
    mixins: [StockPriceHelperMixin],
    computed: {
        defaultConversion() {
            return this.$store.getters.getDefaultConversion;
        },
        cur1() {
            return this.defaultConversion.split(',')[0];
        },
        cur2() {
            return this.defaultConversion.split(',')[1];
        },
        value2() {
            return this.exchangeRate(this.defaultConversion.split(',').join('')) || 0;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/styles/breakpoints.scss";
.curTicker {
    display: flex;
    align-items: center;
    gap: 5px;
    .tName {
    }
    .tValue {
        font-weight: bold;
        color: var(--agora);
    }
    @media screen and (max-width: $small) {
        font-size: 0.75em;
    }
}
</style>